module.exports = __webpack_public_path__ + "img/service_images_bg_03.9efb0568.png";